import WildAppResource from "./WildAppResource";

class TierAppResource extends WildAppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'tier';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'tiers';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'number',
            'sellerLegalHours',
            'sellerYearsLegalProtection',
            'sellerPayNowPrice',
            'sellerPayAtClosePrice',
            'agentLegalHours',
            'agentYearsLegalProtection',
            'agentPayNowPrice',
            'agentPayAtClosePrice',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {};
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {};
    }

}

export default TierAppResource;
